import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  actionLabel,
  actionTo,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="max-w-2xl">
        <div className="flex items-center gap-2">
          <span className="h-px w-8 bg-accent-500" />
          <span className="font-label text-xs tracking-[0.28em] text-accent-500">{eyebrow}</span>
        </div>
        <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">{title}</h2>
        {description && (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">{description}</p>
        )}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 font-label text-sm text-foreground-800 transition-colors hover:border-accent-500 hover:text-accent-400"
        >
          {actionLabel}
          <i className="ri-arrow-right-line text-sm leading-none" />
        </Link>
      )}
    </div>
  );
}